import types from 'constants/CheckinConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
	current: {
    date: "xxxx-xx-xx",
    records: [{
      'sid': 0,
      'siteName': "沒有任何編更記錄",
      'checkinAt': null
    },{
      'sid': 1,
      'siteName': "沒有任何編更記錄",
      'checkinAt': null
    },{
      'sid': 2,
      'siteName': "沒有任何編更記錄",
      'checkinAt': null,
      'checkoutAt': null
    }]
  },
  upcoming: {
    date: "xxxx-xx-xx",
    records: []
  }
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.REFRESH_CHECKIN_RECORD:
      return state.set('current', Immutable.fromJS(action.current))
                  .set('upcoming', Immutable.fromJS(action.upcoming));

    case types.UPDATE_RECORD_ATTR:
      return state.setIn(['current', 'records', action.sid, action.attr], action.value);

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Checkin.js